function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var shortExpressions = {
  en: {
    s: '1s',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd'
  },
  nl: {
    s: '1sec.',
    ss: '%dsec.',
    m: '1min.',
    mm: '%dmin.',
    h: '1u.',
    hh: '%du.'
  },
  cs: {
    s: '1sek',
    ss: '%dsek',
    m: '1min',
    mm: '%dmin',
    h: '1hod',
    hh: '%dhod'
  },
  da: {
    s: '1s',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1t',
    hh: '%dt'
  },
  de: {
    s: '1Sek.',
    ss: '%dSek.',
    m: '1Min.',
    mm: '%dMin.',
    h: '1Std.',
    hh: '%dStd.'
  },
  fr: {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh'
  },
  hi: {
    s: '1से',
    ss: '%dसे',
    m: '1मि',
    mm: '%dमि',
    h: '1घंटा',
    hh: '%dघंटा'
  },
  it: {
    s: '1sec',
    ss: '%dsec',
    m: '1min',
    mm: '%dmin',
    h: '1ora',
    hh: '%dore'
  },
  ja: {
    s: '1秒',
    ss: '%d秒',
    m: '1分',
    mm: '%d分',
    h: '1時間',
    hh: '%d時間'
  },
  ko: {
    s: '1초',
    ss: '%d초',
    m: '1분',
    mm: '%d분',
    h: '1시간',
    hh: '%d시간'
  },
  lt: {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1val',
    hh: '%dval'
  },
  nb: {
    s: '1sek',
    ss: '%dsek',
    m: '1min',
    mm: '%dmin',
    h: '1time',
    hh: '%dtimer'
  },
  pl: {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh'
  },
  pt: {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh'
  },
  es: {
    s: '1seg',
    ss: '%dseg',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dhs'
  },
  sv: {
    s: '1s',
    ss: '%ds',
    m: '1min',
    mm: '%dmin',
    h: '1h',
    hh: '%dh'
  },
  th: {
    s: '1วินาที',
    ss: '%dวินาที',
    m: '1นาที',
    mm: '%dนาที',
    h: '1ชั่วโมง',
    hh: '%dชั่วโมง'
  },
  tr: {
    s: '1sn.',
    ss: '%dsn.',
    m: '1dk.',
    mm: '%ddk.',
    h: '1sa.',
    hh: '%dsa.'
  },
  ru: {
    s: '1сек.',
    ss: '%dсек.',
    m: '1dмин.',
    mm: '%dмин.',
    h: '1ч.',
    hh: '%dч.'
  },
  'zh-cn': {
    s: '1秒',
    ss: '%d秒',
    m: '1d分鐘',
    mm: '%d分鐘',
    h: '1小時',
    hh: '%d小時'
  },
  uk: {
    s: '1с.',
    ss: '%dс.',
    m: '1dхв.',
    mm: '%dхв.',
    h: '1г.',
    hh: '%dг.'
  }
};

var applyShortenedExpression = function applyShortenedExpression(language, timeUnit, value) {
  var _unitToShorthand;

  var placeholder = '%d';
  var unitToShorthand = (_unitToShorthand = {}, _unitToShorthand[TIME_UNIT.SECONDS] = 'ss', _unitToShorthand[TIME_UNIT.MINUTES] = 'mm', _unitToShorthand[TIME_UNIT.HOURS] = 'hh', _unitToShorthand[TIME_UNIT.DAYS] = 'dd', _unitToShorthand);
  var shorthand = value === -1 ? unitToShorthand[timeUnit][0] : unitToShorthand[timeUnit];
  var expression = shortExpressions[language] ? shortExpressions[language][shorthand] : null;

  if (expression) {
    return expression.replace(placeholder, -value);
  }

  return null;
};

var TIME_UNIT = {
  SECONDS: 'second',
  MINUTES: 'minute',
  HOURS: 'hour',
  DAYS: 'day'
};

var getTimeUnit = function getTimeUnit(time) {
  var timeAdjusted = time < 0 ? -time : time;

  switch (true) {
    case timeAdjusted < 1000 * 60:
      return TIME_UNIT.SECONDS;

    case timeAdjusted < 1000 * 60 * 60:
      return TIME_UNIT.MINUTES;

    case timeAdjusted < 1000 * 60 * 60 * 24:
      return TIME_UNIT.HOURS;

    default:
      return TIME_UNIT.DAYS;
  }
};

var getRelativeTime = function getRelativeTime(time, unit, floorSeconds) {
  var returnTime;

  switch (unit) {
    case TIME_UNIT.SECONDS:
      if (floorSeconds) {
        returnTime = 1;
      } else {
        returnTime = time / 1000;
      }

      break;

    case TIME_UNIT.MINUTES:
      returnTime = time / 1000 / 60;
      break;

    case TIME_UNIT.HOURS:
      returnTime = time / 1000 / 60 / 60;
      break;

    case TIME_UNIT.DAYS:
      returnTime = time / 1000 / 60 / 60 / 24;
      break;

    default:
      returnTime = time;
  }

  return -Math.round(returnTime);
};

var isLibAvailable = function isLibAvailable() {
  return typeof Intl.RelativeTimeFormat !== 'undefined';
};

export var createRtfFormatter = function createRtfFormatter(language, _temp, options) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$floorSeconds = _ref.floorSeconds,
      floorSeconds = _ref$floorSeconds === void 0 ? false : _ref$floorSeconds,
      _ref$extraShortExpres = _ref.extraShortExpression,
      extraShortExpression = _ref$extraShortExpres === void 0 ? false : _ref$extraShortExpres;

  if (options === void 0) {
    options = {};
  }

  var rtf;
  return function (time) {
    if (!rtf && isLibAvailable()) {
      rtf = new Intl.RelativeTimeFormat(language, _objectSpread({}, options));
    }

    var timeDiff = new Date().getTime() - new Date(time).getTime();

    if (isNaN(timeDiff)) {
      console.error("[@wix/wix-i18n-config/relative-time-formatter] received invalid time: " + time);
      timeDiff = 1000;
    }

    var unit = getTimeUnit(timeDiff);
    var relativeTime = getRelativeTime(timeDiff, unit, floorSeconds);
    var shortExpression = extraShortExpression || !rtf ? applyShortenedExpression(language, unit, relativeTime) : null;

    if (shortExpression) {
      return shortExpression;
    }

    if (rtf) {
      return rtf.format(relativeTime, unit);
    }

    return time;
  };
};